import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import AppAPI from "../../api";

export interface ListData {
  value: number;
  titleRu: string;
  titleEn: string;
  orderRu: number;
  orderEn: number;
}

export interface ActivitiesListData extends ListData {
  options: Array<ListData>;
}

export interface PaginationData {
  totalCount: number;
  pageCount: number;
  currentPage: number;
  perPage: number;
}

export interface AppSliceState {
  grid: Array<any>;
  pagination: PaginationData | null;
  countries: Array<ListData>;
  activities: Array<ActivitiesListData>;
  categories: Array<ListData>;
  filter: any;
}

const initialFilter = {
  global: "",
  country: "",
  activity: [],
  st: false
}

const initialState: AppSliceState = {
  grid: [],
  countries: [],
  activities: [],
  categories: [],
  filter: initialFilter,
  pagination: null
}

const AppSlice = createSlice({
  name: "AppSlice",
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filter = action.payload
    },
    setFilterField(state, { payload }: PayloadAction<{ name: string, value: any }>) {
      state.filter[payload.name] = payload.value
      state.filter.seo = undefined
    },
    setGlobalFilter(state, { payload }: PayloadAction<string>) {
      state.filter = {
        seo: payload
      }
    },
    clearFilter(state) {
      state.filter = initialFilter
    },
    setPage(state, action) {
      if (state.pagination) {
        state.pagination.currentPage = action.payload
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(AppAPI.endpoints.getTableData.matchFulfilled, (state, action) => {
        state.grid = action.payload.grid
        state.pagination = action.payload.pagination
      })
      .addMatcher(AppAPI.endpoints.getCountries.matchFulfilled, (state, action) => {
        state.countries = action.payload
      })
      .addMatcher(AppAPI.endpoints.getActivities.matchFulfilled, (state, action) => {
        state.activities = action.payload
      })
      .addMatcher(AppAPI.endpoints.getCategories.matchFulfilled, (state, action) => {
        state.categories = action.payload
      })
  }
})

export default AppSlice
export const {
  setFilter,
  setFilterField,
  setGlobalFilter,
  clearFilter,
  setPage
} = AppSlice.actions
